import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { gbpOffer } from '../../config/gbpOffer';
export default function GbpOfferBar() {
 const { pathname } = useLocation();
 if (pathname === gbpOffer.path) return null;
 return <Link to={gbpOffer.path} className="flex min-h-11 w-full items-center justify-center bg-[#F49558] px-5 py-2 text-center text-sm font-bold text-[#101F1F] transition hover:bg-[#F6D541]">Get 3 months free. Tap here.</Link>;
}